export enum IntegrationProvider {
  CODAT = 'CODAT',
  MERGE = 'MERGE',
  STRIPE = 'STRIPE',
  AIRWALLEX = 'AIRWALLEX',
  STIGG = 'STIGG',
}
